import PouchDB from 'pouchdb-browser';
import { CLUB_DB, DB_URL, PSWD, USN } from '../../utils/constants';

export const CLUB_ROLE = ['admin', 'manager'];
export type ECLUB_ROLE = 'admin' | 'manager' | string;

export interface IOwner {
    id: string;
    role: ECLUB_ROLE;
    name: string;
    email?: string;
    status: 'pending' | 'approved';
}

export enum ERangeUnit {
    YARDS = 'Y',
    METERS = 'M',
}

export interface IRange {
    name: string;
    distances: Array<number>;
    unit: ERangeUnit;
    location: string;
}

export interface IClubDivisions {
    divKey: string;
    divName: string;
    discipline?: string;
}

export interface IClubDisciplines {
    name: string;
    scoringSystem: EScoringSystem;
    color: string;
}

export enum EScoringSystem {
    BULLSEYE_V5 = 'BULLSEYE_V5',
    BULLSEYE_X10 = 'BULLSEYE_X10',
    BULLSEYE_XV5 = 'BULLSEYE_XV5',
}

export interface IClub {
    _id: string;
    _rev?: string;
    owners?: Array<IOwner>;
    fullname: string;
    clubName?: string;
    email: string;
    clubEmail?: string;
    contactNumber?: string;
    address?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    ranges?: Array<IRange>;
    visibility?: boolean;
    newsletter?: boolean;
    agree?: boolean;
    doc_type: 'club' | string;
    facebook?: string;
    logo?: string;
    isStateClub?: boolean;
    isNationalClub?: boolean;
    isWorldClub?: boolean;
    clubDivisions?: Array<IClubDivisions>;
    clubDisciplines?: Array<IClubDisciplines>;
    timestamp?: Date;
    currency?: string;
    tumKey?: string;
    domain?: string;
    integrations?: Array<string>;
    termsId?: string;
}

export interface IClubTerms {
    id: number;
    clubId: string;
    type: ETermType;
    termName?: string; // Optional field for file name or Link
    term: string;
}

export enum ETermType {
    LINK = 'LINK',
    FILE = 'FILE',
    TEXT = 'TEXT',
}

export interface IMembershipResponse {
    membershipId: string;
    membershipNumber: string;
    email: string;
    secondaryEmail: string;
    membershipTypeId: number;
    membershipTypeName: string;
    startDate: Date;
    endDate: Date;
    manageLink: string | null;
  }
  
  export interface IUserMembershipsResponse {
    membershipId: string;
    membershipNumber: string;
    status: MembershipStatusEnum;
    startDate: string; // ISO date string
    endDate: string; // ISO date string
    membershipTypeId: string; // Use string for Guid
    membershipTypeName: string;
    manageLink?: string;
    orgName: string;
    orgId: string; // Use string for Guid
    orgWebsite?: string;
  }
  
  export enum MembershipStatusEnum {
    Active = "Active",
    Expired = "Expired",
    Renewed = "Renewed",
    Cancelled = "Cancelled",
    Changed = "Changed",
    PendingApproval = "PendingApproval",
  }

export const clubDB = () =>
    new PouchDB<IClub>(`${DB_URL}/${CLUB_DB}`, {
        skip_setup: true,
        auth: { username: USN, password: PSWD },
        fetch: function (url, opts) {
            return PouchDB.fetch(url, opts);
        },
    });

export const findClubsByOwner = async (owner: string, isAdmin?: boolean) => {
    await clubDB().createIndex({
        index: { fields: ['_id', 'owners'] },
    });
    const clubs = await clubDB().find({
        selector: {
            ...(!isAdmin && {
                owners: {
                    $elemMatch: {
                        id: owner,
                    },
                },
            }),
        },
        limit: 1000,
    });
    return clubs.docs;
};

export const getAllClubs = async (ids?: Array<string>) => {
    const clubs = await clubDB().allDocs({ include_docs: true, ...(ids && { keys: ids }) });
    return clubs.rows.map((row) => row.doc).filter((each) => Boolean(each?.clubName));
};
